import { css } from '@emotion/core';

export const buttonIconStyles = css`
  margin-right: 2px;
`;
